import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackFreshPromos } from './tracking';
import { FreshPromoList } from '../../components/FreshPromoList';
import { prepareNewbuildingPromosAnchor } from '../../mappers';
import { selectPage } from '../../selectors/analytics';
import { selectNewbuildingPromos } from '../../selectors/promosPage';
import { INewbuildingPromo } from '../../types/promosPage';

export const FreshPromoListContainer: React.FC<{}> = () => {
  const promoList = useSelector(selectNewbuildingPromos);
  const page = useSelector(selectPage);
  const { siteType } = page;
  const anchor = prepareNewbuildingPromosAnchor(siteType);

  const handleViewedAction = React.useCallback(
    (position: number, promo: INewbuildingPromo) => {
      trackFreshPromos({ action: 'show_sopr', position, promo, page });
    },
    [page],
  );

  const handleClick = React.useCallback(
    (position: number, promo: INewbuildingPromo) => {
      trackFreshPromos({ action: 'Click', position, promo, page });
      window.open(`${promo.newbuildingUrl}${anchor}`);
    },
    [page, anchor],
  );

  if (promoList.length === 0) {
    return null;
  }

  return (
    <FreshPromoList
      title={'Новые предложения в ЖК'}
      promoList={promoList}
      onCardView={handleViewedAction}
      onCardClick={handleClick}
    />
  );
};
